import { ref, watch } from 'vue'

export const hubspotModalDataId = ref('')

/**
 * Id of the visible Hubspot modal instance
 * when it is set as empty string, it means that
 * no modal is visible,
 *
 * @see src/components/Vue/HubspotModal.vue
 */
export const hubspotModalInstanceId = ref('')

watch(hubspotModalInstanceId, (value) => {
  if (value === '') {
    hubspotModalDataId.value = ''
  }
})
